import React from 'react';

export interface LineWrappedComponentProps {
  lineHeight?: string;
  children: React.ReactNode;
}

export default function LineWrappedComponent(props: LineWrappedComponentProps) {
  const { lineHeight = '5px', children } = props;

  const inlineStyles = {
    height: lineHeight,
    borderRadius: '999px',
    backgroundColor: '#808080',
    opacity: 0.2,
    flexGrow: 1,
    display: 'block'
  };

  return (
    <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '1rem' }}>
      <span style={inlineStyles} />
      {children}
      <span style={inlineStyles} />
    </div>
  );
}
